export enum ShopsActionTypes {
  FETCH = '@shops/fetch',
  FETCH_STARTED = '@shops/fetch/started',
  FETCH_SUCCEED = '@shops/fetch/succeed',
  FETCH_FAILED = '@shops/fetch/failed',
}
